import {
  GIAHOANTIEN_COUNT_ASSIGN_SUCCESS,
  GIAHOANTIEN_HISTORY_LIST_SUCCESS,
  GIAHOANTIEN_IMPORT_SUCCESS,
  GIAHOANTIEN_LIST_SUCCESS,
  GIAHOANTIEN_NEW_CARE_SUCCESS,
  GIAHOANTIEN_ONE_SUCCESS,
  GIAHOANTIEN_UPDATE_FILTER,
  GIAHOANTIEN_SAVE_SUCCESS,
} from 'src/actions/giahoantien.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    ten_goi_cuoc: '',
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
}

const giahoantienReducer = (state = initState, action) => {
  switch (action.type) {
    case GIAHOANTIEN_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case GIAHOANTIEN_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case GIAHOANTIEN_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case GIAHOANTIEN_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case GIAHOANTIEN_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case GIAHOANTIEN_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case GIAHOANTIEN_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case GIAHOANTIEN_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    default: {
      return state;
    }
  }
}
export default giahoantienReducer